<template>
  <div>
    <!-- user access is disabled -->
    <div v-if="!config.IS_USER_ACTIVE">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert class="info text-xs-center" value="true">
              Access is currently denied for your account
              <br /><br />
              Please contact your Community Admin / Integra Back Office to grant access.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- one or more of user's joining request not approved yet -->
    <div v-else-if="config.IS_USER_ACTIVE && config.ALL_UNITS.findIndex(rec => rec.rel_status !== 'Linked') >= 0">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span v-for="(unit, i) in config.ALL_UNITS.filter(rec => rec.rel_status !== 'Linked')" :key="i" color="info" class="text-xs-center" value="true">
              <v-alert v-if="unit.rel_status === 'Pending Approval'">
                Your joining request for <span class="subheading yellow--text">{{(unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + config.COMM_NAME}}</span> is yet to be approved by your community admin.
                <br /><br />
                It may take few hours to process your request and you will be notified as soon as it is done.
                <div>
                  <v-btn class="mb-0" flat color="accent" @click="logout">Logout</v-btn>
                </div>
              </v-alert>
              <v-alert v-else-if="unit.rel_status === 'Rejected'">
                Your joining request for <span class="yellow--text">{{unit.block_nm + ' ' + unit.unit_no}}</span> was rejected with below reason.
                <div class="text-xs-center white--text mt-2">
                  "{{ unit.rej_reason }}"
                </div>
                <div>
                  <v-btn flat class="mb-0" color="accent" @click="cancelReq(unit)">Cancel & Sign-up again</v-btn>
                </div>
              </v-alert>
              <v-alert v-else-if="unit.rel_status === 'Delinked' && config.ALL_UNITS.length === 1">
                You are currently delinked from <span class="yellow--text">{{(unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + config.COMM_NAME}}</span>
                <br /><br />
                Please contact your Community Admin / Integra Back Office if you did not expect to see this message.
                <div>
                  <v-btn class="mb-0" flat color="accent" @click="logout">Logout</v-btn>
                </div>
              </v-alert>
            </span>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- user has access to atleast one unit -->
    <div v-if="config.IS_USER_ACTIVE && config.UNITS.findIndex(rec => rec.rel_status === 'Linked') >= 0">
      <v-container class="pa-2" grid-list-md>
        <v-layout row wrap>

          <!-- Joining requests -->
          <v-flex xs12 v-if="joinReq.length" class="pb-2">
            <v-card :to="{path: (config.IS_ADMIN ? '/users' : '/profile/join')}">
              <v-card-title class="pa-2 subheading primary lighten-2 white--text">
                Joining Requests
              </v-card-title>
              <v-card-text class="pa-2">
                <span class="ml-2">{{ joinReq.length + ' request' + (joinReq.length > 1 ?'s' : '') }} pending for your review!</span>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="!isMobAdminUser">
        <v-card class="mb-1">
          <v-card-title class="pa-2 subheading primary lighten-2 white--text">
            Welcome to Integra Admin!
          </v-card-title>
          <v-card-text class="pb-1">
            Do you know, you can access this Integra App in your mobile phone as well?
            <v-layout row wrap class="mt-2">
              <v-flex xs6 sm3 class="text-xs-center">
                Android
                <div>
                  <a target="_blank" href='https://play.google.com/store/apps/details?id=in.smartility.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img width="150" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                </div>
              </v-flex>
              <v-flex xs6 sm3 class="text-xs-center">
                iPhone
                <div class="pa-2">
                  <a @click="dlgHowToiPhone=true"><img alt='Install web app' width="140" :src="config.STATIC_FILES_DIR + '/img/others/pwa_app.png'"/></a>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- complaints -->
      <!-- community view for staffs -->
      <!--
      <v-flex xs12>
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/complaints'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">headset_mic</v-icon>Complaints
          </v-card-title>
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs6>
                <span class="subheading">Open</span>
                <div>
                  {{ totOpenComp }}
                </div>
                <v-chip v-if="totNewComp" class="white caption" small>{{totNewComp + ' new'}}</v-chip>
                <v-chip v-if="totCritComp" class="error white--text caption" small>{{totCritComp + ' critical'}}</v-chip>
              </v-flex>
              <v-flex xs6>
                <span class="subheading">Assigend to me</span>
                <br />
                {{ totMine }}
              </v-flex>
            </v-layout>
            <v-btn fab small class="primary lighten-2" style="position:absolute; bottom:1px; right:1px; border:3px solid" :to="{path: '/complaints/create'}">
              <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
      -->
      <!-- Tasks -->
      <v-flex xs6 sm3 v-if="tasks">
        <v-card class="display-1 text-xs-center warning" :to="{path: '/task'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">group_work</v-icon>Task
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{tasks.tot_task}}
            <v-chip v-if="tasks.past_due" class="error white--text caption" small>{{tasks.past_due + ' past due'}}</v-chip>
            <v-chip v-if="tasks.due_today" class="warning white--text caption" small>{{tasks.due_today + ' due today'}}</v-chip>
            <v-chip v-if="tasks.pend_appr" class="white caption" small>{{tasks.pend_appr + ' for your approval'}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-else-if="tasks"> <!-- detailed view for staffs -->
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/task'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">group_work</v-icon>Task
          </v-card-title>
          <v-card-text class="pa-0">
            {{tasks ? tasks.tot_task : 0}}
            <v-chip v-if="tasks && tasks.past_due" class="error white--text caption" small>{{tasks.past_due + ' past due'}}</v-chip>
            <v-chip v-if="tasks && tasks.due_today" class="warning white--text caption" small>{{tasks.due_today + ' due today'}}</v-chip>
            <v-chip v-if="tasks && tasks.pend_appr" class="white caption" small>{{tasks.pend_appr + ' for your approval'}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- facility management for staffs -->
      <v-flex xs12 class="pt-2">
        <v-card class="display-1 primary lighten-2">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">engineering</v-icon>Facility Management
            <v-spacer></v-spacer>
            <v-chip small disabled :class="'caption ml-0 mr-1 black--text ' + (statDay === 'yesterday' ? 'primary lighten-5' : 'primary lighten-3')" @click="loadStatsForStaffDashboard('yesterday')">yesterday</v-chip>
            <v-chip small disabled :class="'caption ma-0 black--text ' + (statDay === 'today' ? 'primary lighten-5' : 'primary lighten-3')" @click="loadStatsForStaffDashboard('today')">today</v-chip>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex xs6 sm3>
                <v-card flat :to="{path: '/attendance'}">
                  <v-card-title class="pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text">
                    <v-icon class="pr-2 warning--text">camera_front</v-icon>Attendance
                    <v-spacer></v-spacer>
                  </v-card-title>
                </v-card>
                <v-card :to="{path: '/attendance'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:85px;">
                    <div class="text-xs-center white--text" style="font-size: 24px">
                      {{(attend.percent || 0) + '%'}}<br />
                      <v-chip v-if="attend.tot_pend" class="red white--text" style="font-size: 12px" small>{{attend.tot_pend + ' pending'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat>
                  <v-card-title class="pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text">
                    <v-icon class="pr-2 warning--text">today</v-icon>Daily Update
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="showDateList = true"><v-icon color="white">open_in_new</v-icon></v-btn>
                  </v-card-title>
                </v-card>
                <v-card :to="{path: '/dailyupdate'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:85px;">
                    <div class="text-xs-center white--text" style="font-size: 22px">
                      {{dailyUpdate.c_date ? (dailyUpdate.is_sub_app || dailyUpdate.is_app ? 'Done' : 'Draft' ) : 'Pending'}} <br />
                      <v-chip v-if="dailyUpdate.tot_pend" class="red white--text caption" style="font-size: 12px" small>{{dailyUpdate.tot_pend + ' days pending'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat :to="{path: '/inventory'}">
                  <v-card-title class="pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text">
                    <v-icon class="pr-2 warning--text">category</v-icon>Assets
                    <v-spacer></v-spacer>
                  </v-card-title>
                </v-card>
                <v-card :to="{path: '/inventory'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:85px;">
                    <div class="text-xs-center white--text" style="font-size: 26px">
                      <span v-if="assets.amc_past_due">{{assets.amc_past_due}} <span class="red--text body-1">AMC past due</span><br /></span>
                      {{assets.amc_due_soon}} <span :class="'body-1 ' + (assets.amc_due_soon ? 'red--text' : '')">AMC due soon</span>
                      <v-chip v-if="assets.tot_outside" class="white caption" small>{{assets.tot_outside + ' out for service'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat :to="{path: '/incidents'}">
                  <v-card-title class="pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text">
                    <v-icon class="pr-2 warning--text">report_problem</v-icon>Incidents
                    <v-spacer></v-spacer>
                  </v-card-title>
                </v-card>
                <v-card :to="{path: '/incidents'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:85px;">
                    <div class="text-xs-center white--text" style="font-size: 26px">
                      {{incidents.length || 0}}
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dlgHowToiPhone" max-width="500px">
      <v-card flat>
        <v-card-title class="title pb-1">
          How to install in iPhone?
        </v-card-title>
        <v-card-text>
          <ul class="mt-2">
            <li>
              Open your safari browser
            </li>
            <li>
              Go to <a href="https://app.integrafms.com" target="_blank">https://app.integrafms.com</a>
            </li>
            <li>
              Tap on share icon at the bottom of your browser window
            </li>
            <li>
              Tap on "Add to Home Screen" to install the app
            </li>
          </ul>
          <div class="text-xs-center">
            <img width="85%" :src="config.STATIC_FILES_DIR + '/img/others/pwa_install.png'"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgHowToiPhone=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

</v-container>
</div>

<v-dialog v-model="showDateList" scrollable max-width="500px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      List Of FM Daily Update Pending dates
      <v-spacer></v-spacer>
      <v-btn icon @click="showDateList = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="dateHeader"
      :items="dailyUpdate.dateList"
      class="elevation-1"
      hide-actions>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ handy.formatDate(props.item.selected_date) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- display water mark if there is too much space in dashboard, usually will happen for a fresh user/community -->
<div>
  <v-container>
    <v-layout>
      <v-flex xs12 class="text-xs-center mt-4" style="opacity: 0.25;">
        <img height="100" width="250" :src="config.STATIC_FILES_DIR + '/img/logo/integra_logo.png'">
      </img>
    </v-flex>
  </v-layout>
</v-container>
</div>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { logout } from '@/utils/auth'

export default {
  data () {
    return {
      // common
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      handy: handy,
      config: config,
      beingSaved: false,
      show: false,
      // admins
      joinReq: [],
      tasks: '',
      // complaints
      totMine: 0,
      totOpenComp: 0,
      totNewComp: 0,
      totCritComp: 0,
      totPersComp: 0,
      // fm
      statDay: 'today',
      attend: '',
      dailyUpdate: '',
      assets: '',
      incidents: '',
      totalLikes: [],
      totalPinned: [],
      totalComment: [],
      showDateList: false,
      dateHeader: [
        { text: 'Dates', values: 'selected_date' }
      ],
      dlgHowToResDir: false,
      dlgHowToSecGaurd: false,
      dlgHowToiPhone: false,
      commSetupScore: {subscription: {}, setup_score: {}},
      isCommSetupPend: false,
      isMobAdminUser: true,
      dlgCommSetup: false
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    },
    nextThreeDays: function () {
      let curDt = new Date()
      curDt.setDate(curDt.getDate() + 3)
      return handy.formatDBDate(curDt)
    },
    totDlgNotice: function () {
      if (this.notices.length) {
        this.dlgNotice = true
      } else {
        this.dlgNotice = false
      }
      return this.notices.length
    }
  },
  created () {
    this.refreshDashboard()
  },
  watch: {
    '$route' (to, from) {
      this.refreshDashboard()
      this.$forceUpdate()
    }
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    refreshDashboard () {
      // note: all these methods are asyncronous and will be loaded independantly
      this.loadIsMobAdminUser()
      if (config.UNIT_ID_LIST.length || config.IS_ADMIN) {
        this.loadJoinReq()
      }
      this.loadComps()
      this.loadTasks()
      if (config.IS_OTHER_USER) {
        this.loadStatsForStaffDashboard()
      }
    },
    cancelReq (curUnit) {
      if (confirm('Sure, you want to cancel the request?')) {
        var req = {
          unit_id: curUnit.unit_id,
          cust_id: config.CUST_ID,
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          is_other_user: config.IS_OTHER_USER
        }
        this.axios.post(config.API_URL + '/admin/cancel-req', req)
        .then(response => {
          // refresh list in front end
          logout()
        })
        .catch(err => {
          this.msg(err.response.data, true)
        })
      }
    },
    logout () {
      logout()
    },
    loadTasks () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getOpenTaskSummaryByUserId/', qry)
      .then(response => {
        this.tasks = response.data[0]
      })
    },
    loadComps () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // users complaints (created by / assigned to this user)
      this.totMine = 0
      this.axios.get(config.API_URL + '/getComplaintsByUser/', qry)
      .then(response => {
        this.totMine = response.data.length
      })
      // all open complaints
      this.totOpenComp = 0
      this.totNewComp = 0
      this.totCritComp = 0
      this.axios.get(config.API_URL + '/getComplaintsByComm/', qry)
      .then(response => {
        this.totOpenComp = response.data.length
        this.totNewComp = response.data.filter(rec => rec.comp_status === 'New').length
        this.totCritComp = response.data.filter(rec => rec.comp_severity === 'Critical').length
      })
    },
    loadIsMobAdminUser () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // load joining request of new user for the particular community
      this.axios.get(config.API_URL + '/getIsMobileAdminUser/', qry)
      .then(response => {
        this.isMobAdminUser = response.data.length
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadJoinReq () {
      var qry = {
        params: {
          unit_id_list: config.UNIT_ID_LIST,
          comm_id: config.COMM_ID,
          is_admin: config.IS_ADMIN,
          user_id: config.USER_ID
        }
      }
      // load joining request of new user for the particular community
      this.axios.get(config.API_URL + '/getJoiningRequest/', qry)
      .then(response => {
        this.joinReq = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.joinReq = []
      })
    },
    loadStatsForStaffDashboard (statDay = this.statDay) {
      this.statDay = statDay
      let statDate = this.today
      if (statDay === 'yesterday') {
        var curDate = new Date()
        statDate = handy.formatDBDate(curDate.setDate(curDate.getDate() - 1))
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          stat_dt: statDate
        }
      }
      // all open complaints
      this.axios.get(config.API_URL + '/getComplaintsByComm/', qry)
      .then(response => {
        this.totOpenComp = response.data.length
        this.totNewComp = response.data.filter(rec => rec.comp_status === 'New').length
        this.totCritComp = response.data.filter(rec => rec.comp_severity === 'Critical').length
      })
      // attendace
      this.axios.get(config.API_URL + '/getAttendanceStat/', qry)
      .then(response => {
        this.attend = response.data
      })
      // daily update
      this.axios.get(config.API_URL + '/getDailyUpdateStat/', qry)
      .then(response => {
        this.dailyUpdate = response.data
      })
      // asset
      this.axios.get(config.API_URL + '/getAssetsForAMCDue/', qry)
      .then(response => {
        this.assets = response.data
      })
      // incidents
      qry.params.incident_status = 'Open'
      qry.params.as_on = qry.params.stat_dt
      this.axios.get(config.API_URL + '/getIncidentsByCommId/', qry)
      .then(response => {
        this.incidents = response.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?5fb2177d